<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col>
        <a-form layout="inline">
          <a-form-item>
            <a-select v-model="searchFrom.org_id" placeholder="机构" style="width: 120px;">
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="(item) in orgList" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.status" placeholder="状态" style="width: 120px;">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="1">可用</a-select-option>
              <a-select-option value="0">已禁用</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select v-model="searchFrom.demon" placeholder="是否演示" style="width: 120px;">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="1">正常</a-select-option>
              <a-select-option value="0">演示</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-input placeholder="校区名字" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="tableAdd">创建校区</a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div class="campus-count">
      <span>共 {{ pageinfo.total }} 个校区</span>
    </div>
    <div>
      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>
        <a-table-column key="name" title="校区名字" data-index="name" />
        <a-table-column key="orgname" title="所属机构" data-index="orgname" />
        <a-table-column key="address" title="地址" data-index="address" />
        <a-table-column key="campusadmin" title="管理员" data-index="campusadmin" />
        <a-table-column key="demon" width="100px;" title="是否演示">
          <template slot-scope="item">
            <span v-if="item.demon == 1">正常</span>
            <span v-if="item.demon == 0">演示</span>
          </template>
        </a-table-column>
        <a-table-column key="status" width="100px;" title="状态">
          <template slot-scope="item">
            <span v-if="item.status == 1">可用</span>
            <span v-if="item.status == 0">已禁用</span>
          </template>
        </a-table-column>
        <a-table-column key="active" width="200px" title="操作">
          <template slot-scope="item">
            <a-button v-if="item.status == 0" @click="changeStatus({ id: item.id, status: 1, management: item.management })"
              class="active_btn" size="small" type="link">启用
            </a-button>
            <a-button v-if="item.status == 1" @click="changeStatus({ id: item.id, status: 0, management: item.management })"
              class="active_btn" size="small" type="link">禁用
            </a-button>
            <a-button v-if="item.status == 1" @click="tableEdit(item)" class="active_btn" size="small" type="link">编辑
            </a-button>
            <router-link :to="{ path: '/orgcampusinfo', query: { id: item.id } }">查看详情</router-link>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :visible="visible" title="校区信息" @ok="modalSave" :destroyOnClose="true" @cancel="modalCancel">
      <a-form>
        <a-input type="hidden" v-model="form.id" />
        <a-form-item>
          <a-input v-model="form.name" placeholder="校区名字" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.address" placeholder="地址" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.gps" placeholder="GPS位置" />
        </a-form-item>
        <a-form-item>
          <or-upload v-model="form.campus_logo" mode="image" @input="uploadfile" button-text="上传校区图标" />
         
        </a-form-item>
      
        <a-form-item>
          
          <a-select
            v-model="form.admin_id"
            placeholder="输入管理员手机号或名字"
            style="width: 100%;"
            show-search
            :filter-option="false"
            :not-found-content="null"
            :default-active-first-option="false"
            @search="searchAdmin"
          >
            <a-select-option v-for="item in filteredAdminList" :key="item.id" :value="item.id">
              {{ item.nickname }}-{{ item.mobile }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.demon" placeholder="是否演示" style="width: 100%;">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="0">演示</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </or-layout>
</template>
<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
import OrUpload from "@/components/upload";
export default {
  components: { AFormItem, OrUpload },
  data() {
    return {
      searchFrom: {
        keyword: undefined,
        org_id: undefined,
        status: '1', // 默认搜索可用状态
        demon: '1' // 默认选中正常
      },
      data: [],
      pageinfo: { total: 1, current: 1, pageSize: 10 },
      loading: false,
      visible: false,
      adminList: [],
      orgList: [],
      form: {
        id: undefined,
        name: undefined,
        campus_logo: undefined,
        gps: undefined,
        address: undefined,
        admin_id: undefined,
        demon: '1' // 默认正常
      },
      filteredAdminList: []
    };
  },
  mounted() {
    this.tableSearch();
    this.getOrgSquadlist();
  },
  methods: {
    selectItem(pid) {
      this.form.pid = pid;
    },
    getOrgSquadlist() {
      this.$axios
        .post("/api/OrgOrganization/index")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.orgList = res.data.data;
            // console.info(this.orgList);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },


    changeStatus(data) {
      this.$axios
        .post("/api/OrgCampus/enable", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.getTableList();
    },
    uploadfile() {
      console.info("上传文件:", this.form.org_logo);
    },
    tableSearch() {
      this.pageinfo.current = 1;
      this.getTableList();
    },
    searchAdmin(value) {
      if (!value) {
        this.filteredAdminList = [];
        return;
      }
      this.$axios
        .post("/api/Admin/index", { 
          data:{keyword: value},
          pageinfo: { pageSize: 10, current: 1 }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.filteredAdminList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getTableList() {
      this.loading = true;
      this.$axios
        .post("/api/OrgCampus/index", {
          data: this.searchFrom,
          pageinfo: this.pageinfo
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.data = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tableEdit(item) {
      console.info("item", item);
      // this.form =item;
      this.form.id = item.id;
      this.form.name = item.name;
      this.form.campus_logo = item.campus_logo;
      this.form.gps = item.gps;
      this.form.address = item.address;
      this.form.demon = item.demon;
      // 查找匹配的管理员并赋值
      this.form.admin_id = item.admin_id,
        this.visible = true;
    },

    tableAdd() {
      this.visible = true;
      this.form.id = undefined;
      this.form.name = undefined;
      this.form.campus_logo = undefined;
      this.form.gps = undefined;
      this.form.address = undefined;
      this.form.admin_id = undefined;
      this.form.demon = '1';
      this.filteredAdminList = [];
    },
    tableEdit(item) {
      this.visible = true;
      this.form.id = item.id;
      this.form.name = item.name;
      this.form.campus_logo = item.campus_logo;
      this.form.gps = item.gps;
      this.form.address = item.address;
      this.form.demon = item.demon;
      // 设置管理员信息
      if (item.admin_id && item.campusadmin) {
        this.form.admin_id = item.admin_id;
        this.filteredAdminList = [{
          id: item.admin_id,
          nickname: item.campusadmin.split('-')[0],
          mobile: item.campusadmin.split('-')[1]
        }];
      }
    },

    tableDel(data) {
      let _this = this;
      this.$confirm({
        title: "删除权限",
        content: "确认删除当前权限吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/OrgCampus/del", { data })
            .then(res => {
              if (res.code != 200) {
                _this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.getTableList();
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    modalSave() {
      let url = "/api/OrgCampus/edit";
      if (!this.form.id) {
        url = "/api/OrgCampus/add";
      }
      this.$axios
        .post(url, { data: this.form })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.getTableList();
            this.visible = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    modalCancel() {
      this.visible = false;
      this.filteredAdminList = [];
    }
  }
};
</script>
<style>
.active_btn {
  margin-left: 5px;
}
.campus-count {
  margin-bottom: 16px; /* 调整与列表的间距 */
  font-size: 16px; /* 放大字体 */
  font-weight: bold; /* 加粗字体 */
}
</style>
